<template>
  <div :class="['select-accordion']" @click.prevent.stop="open=true">
    <div class="select-accordion__button d-flex justify-content-between">
      <div class="mr-1 text-nowrap font-weight-bold">
        {{ name }}:
      </div>
      <div class="d-flex justify-content-end">
        <div class="selected-value d-inline-block text-truncate">
          {{ selectedValue }}
        </div>
        <div class="ml-2">
          <font-awesome-icon icon="chevron-down" />
        </div>
      </div>
    </div>
    <b-collapse :id="hash" v-model="open" class="select-accordion__options" :accordion="accordionName">
      <slot>
        <div v-if="nullValue && name !== 'Lead Type'"
             :key="'nv'"
             class="select-accordion__item"
             @click.prevent.stop="select({value:null, text: $t('Do not filter')})"
        >
          <span>{{ $t('Do not filter') }}</span>
        </div>
        <template v-if="nested">
          <div class="nested-dropdown">
            <div v-for="(category, key) in options"
                 :key="key"
            >
              <template v-if="category.value !== undefined">
                <div class="select-accordion__item font-weight-bold" @click.prevent.stop="select({value:category.value, text:category.label})">
                  <span>
                    <font-awesome-icon v-if="isSelected(category.label)" class="text-success selected-item line-height-1 mb-0" :icon="'circle'" />
                    {{ category.label }}
                  </span>
                </div>
              </template>
              <template v-else>
                <div class="select-accordion__category mr-3">
                  <span class="mb-3 font-weight-bold d-block select-accordion__category--parent py-2 text-center">{{ category.label }}</span>
                  <div v-for="(subCategory, subKey) in category.children"
                       :key="subKey"
                       class="select-accordion__sub-category"
                  >
                    <span class="ml-1 d-block font-italic font-weight-bold py-2">{{ subCategory.label }}</span>
                    <div v-for="(item, labelKey) in subCategory.children"
                         :key="labelKey"
                         class="select-accordion__item"
                         @click.prevent.stop="select(item)"
                    >
                      <span class="ml-2">
                        <font-awesome-icon v-if="isSelected(item.text)" class="text-success selected-item line-height-1 mb-0" :icon="'circle'" />
                        {{ item.text }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item, key) in options"
               :key="key"
               class="select-accordion__item"
               @click.prevent.stop="select(item)"
          >
            <span>{{ item.text }}</span>
          </div>
        </template>
      </slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "SelectAccordion",
  props: ['name', 'options', 'value', 'nullValue', 'accordion'],
  data: function () {
    return {
      selected: {
        text: 'None',
      },
      open: false,
      hash: null,
      optionsWidth: null,
    };
  },
  computed: {
    selectedValue: function () {
      return this.selected.text;
    },
    accordionName: function() {
      return this.accordion ?? this.hash;
    },
    nested: function() {
      return (this.options && this.options[0] && this.options[0].label);
    }
  },
  methods: {
    select: function (value) {
      this.selected = value;
      this.$emit('input', value.value);
      this.close();
    },
    close: function () {
      this.open = false;
    },
    setSelected: function (value) {
      let selected = undefined;
      if (this.options) {
        if (this.nested) {
          this.options.forEach((category) => {
            if (category.value !== undefined && value === category.value) {
              selected = {
                value: category.value,
                text: category.label,
              }
            } else {
              category.children.forEach((subCategory) => {
                subCategory.children.forEach(option => {
                  if(option.value === value) {
                    selected = option;
                  }
                })
              })
            }
          })
        } else {
          selected = this.options.find((option) => option.value === value);
        }
      }
      this.selected = selected !== undefined ? selected : (value === null) ? {
        value: null,
        text: this.$t('Do not filter')
      } : {value: null, text: value};
    },
    isSelected: function(current) {
      return this.selectedValue === current;
    },
  },
  watch: {
    value: function (value) {
      this.setSelected(value);
    },
    options: function (value) {
      if (Array.isArray(value) && value.length > 0) {
        this.selected = value[0];
      }
    },
  },
  created: function () {
    this.setSelected((this.value) ?? ((this.nullValue) ? null : this.options[0].value));
    this.hash = this.name.split('').reduce((a, b) => {
      // eslint-disable-next-line no-param-reassign
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a
    }, 0).toString();
  },
}
</script>

<style scoped lang="scss">

</style>
